"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentDetailsModal = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const constants_1 = require("../../../../../constants/constants");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const DocumentDetailsModal = ({ onSave, type = constants_1.DocumentTypes.DOCUMENT, document, }) => {
    const [emailError, setEmailError] = (0, react_1.useState)([]);
    const [onlySigner, setOnlySigner] = (0, react_1.useState)(false);
    const [documentName, setDocumentName] = (0, react_1.useState)("");
    const [signers, setSigners] = (0, react_1.useState)([]);
    const title = type == constants_1.DocumentTypes.DOCUMENT ? "Document" : "Template";
    function isOnlySigner(value) {
        if (typeof value === "boolean")
            return value;
        if (typeof value === "string")
            return value.toLowerCase() === "yes" || value === "true";
        if (typeof value === "number")
            return value === 1;
        return false;
    }
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (document) {
            setSigners((_a = document === null || document === void 0 ? void 0 : document.signers) !== null && _a !== void 0 ? _a : []);
            setDocumentName((_b = document === null || document === void 0 ? void 0 : document.name) !== null && _b !== void 0 ? _b : "");
            setOnlySigner(isOnlySigner(document === null || document === void 0 ? void 0 : document.only_signer));
        }
    }, [document]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (document && !(document === null || document === void 0 ? void 0 : document.only_signer) && ((_a = document === null || document === void 0 ? void 0 : document.signers) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            setSigners([
                {
                    first_name: "",
                    last_name: "",
                    email: "",
                },
            ]);
        }
        else if (!document) {
            setSigners([
                {
                    first_name: "",
                    last_name: "",
                    email: "",
                },
            ]);
        }
    }, []);
    // Enhanced email validation using browser's native validator
    const validateEmail = (email) => {
        // First check with regex for basic format
        if (!constants_1.EMAIL_VALIDATION.test(email)) {
            return false;
        }
        // Use browser's native email validation for more comprehensive check
        // This catches issues like invalid TLDs (.glabal instead of .global)
        const input = window.document.createElement("input");
        input.type = "email";
        input.value = email;
        return input.checkValidity();
    };
    (0, react_1.useEffect)(() => {
        setEmailError(signers.map((x, index) => {
            if (!x.email) {
                return `Email (${index + 1}) is required`;
            }
            if (x.email && !validateEmail(x.email)) {
                return `Invalid email (${index + 1}) format. Please check for typos (e.g., .glabal should be .global)`;
            }
            return "";
        }));
    }, [signers]);
    const updateSigners = (index, key, value) => {
        let _signers = signers.map((x, i) => {
            if (index === i) {
                return Object.assign(Object.assign({}, x), { [key]: value });
            }
            return x;
        });
        setSigners(_signers);
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 bg-white p-4" },
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: `${title} name`, size: "small", value: documentName, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                    setDocumentName(e);
                }) })),
        type === constants_1.DocumentTypes.DOCUMENT && (react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "I'm the only signer", decorationColor: "decoration-borders", uncheckedColor: "text-textInput", checkedColor: "text-success", value: onlySigner, size: "xsmall", textColor: "text-textInput", onChange: (v) => {
                    setOnlySigner(v);
                    setSigners([]);
                } }))),
        type === constants_1.DocumentTypes.DOCUMENT &&
            !onlySigner &&
            signers.length > 0 &&
            signers.map((x, index) => (react_1.default.createElement("div", { key: `signer-${index}`, className: "flex gap-4" },
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", size: "small", value: x.email, errorText: emailError[index], borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                            updateSigners(index, "email", e);
                        }) })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "First Name", size: "small", value: x.first_name, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                            updateSigners(index, "first_name", e);
                        }) })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Last Name", size: "small", value: x.last_name, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                            updateSigners(index, "last_name", e);
                        }) })),
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faMinus, backgroundColor: "bg-white", borderColor: "border-borders", iconColor: "text-black", size: "xsmall", onClick: () => {
                            setSigners(signers.filter((signer, k) => k !== index));
                        } }))))),
        type === constants_1.DocumentTypes.DOCUMENT && !onlySigner && (react_1.default.createElement("div", { className: "flex justify-end" },
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faAdd, backgroundColor: "bg-white", borderColor: "border-secondary", iconColor: "text-black", size: "xsmall", onClick: () => {
                        setSigners([
                            ...signers,
                            {
                                first_name: "",
                                last_name: "",
                                email: "",
                            },
                        ]);
                    } })))),
        document && (document === null || document === void 0 ? void 0 : document.status) === "DRAFT" && (react_1.default.createElement("div", { className: "flex justify-center mb-4" },
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", onClick: () => {
                    onSave({ documentName, onlySigner, signers, emailError: emailError.filter((x) => x != "") });
                } }))),
        !document && (react_1.default.createElement("div", { className: "flex justify-center mb-4" },
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", onClick: () => {
                    onSave({ documentName, onlySigner, signers, emailError: emailError.filter((x) => x != "") });
                } })))));
};
exports.DocumentDetailsModal = DocumentDetailsModal;
